module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExt.e815c4f.woff";